<template>
  <div class="examQuestionResult">
    <div class="font-bold">
      <span v-if="showPoints">
        {{ calculateQuestionPoints(examQuestion, gradeCalcMode).toFixed(2) }}p
      </span>
      <span v-if="showPoints">
        {{ isSimpleQuestion(examQuestion) ? "CS" : "CM" }}
      </span>
      <span
        v-html="
          (simpleMark && isSimpleQuestion(examQuestion) ? '* ' : '') +
          examQuestion.question.description
        "
      ></span>
      <!--<span v-if="!endWith(examQuestion.question.description)">:</span>-->
    </div>
    <template v-if="examQuestion.question.questionAttachment != null">
      <br />
      <ExamImg
        :src="exam.getQuestImage(examQuestion.question.questionAttachment)"
        fullWidth="90vw"
      ></ExamImg>
    </template>
    <ol class="list-[upper-alpha]">
      <li
        class="ml-8 examAnswer"
        v-for="answ in examQuestion.answerExams.filter(
          (item) =>
            !filterAnswers ||
            item?.answer?.question?.id == examQuestion?.question?.id
        )"
        :key="answ.id"
        v-bind:class="{
          correctAnswer: showResult && answ.answer.isCorrect,
          wrongAnswer: showResult && !answ.answer.isCorrect && answ.isChecked,
          selectedAnswer: showResult && answ.isChecked,
          shouldHaveSelected:
            showResult && !answ.isChecked && answ.answer.isCorrect,
          correctAnswerMarked: markCorrect && answ.answer.isCorrect,
        }"
      >
        <span v-if="showPoints">
          {{
            calculateAnswerPoints(answ, examQuestion, gradeCalcMode).toFixed(2)
          }}p (
          {{ getAnswerPoints(answ, examQuestion, gradeCalcMode).toFixed(2) }}p )
        </span>
        <span v-html="answ.answer.description"></span>
        <template v-if="answ.answer['answerAttachment']">
          <ExamImg
            :src="exam.getAnsImage(answ.answer['answerAttachment'])"
            fullWidth="90vw"
          ></ExamImg>
        </template>
        <v-switch
          :label="$t('templateContestRemoveAnswer')"
          v-model="selectedToRemoveAnswers[answ.answer.id]"
          @change="
            onToggle(answ.answer.id, selectedToRemoveAnswers[answ.answer.id])
          "
          v-if="answersHaveSwitch"
        />
      </li>
    </ol>
  </div>
</template>

<script>
import { exam } from "@/js/exam";
import {
  calculateQuestionPoints,
  calculateAnswerPoints,
  getAnswerPoints,
  isSimpleQuestion,
} from "@/js/helpers";
export default {
  name: "ExamQuestionResult",
  props: {
    examQuestion: Object,
    gradeCalcMode: String,
    showPoints: {
      type: Boolean,
      default: true,
    },
    showResult: {
      type: Boolean,
      default: true,
    },
    simpleMark: {
      type: Boolean,
      default: false,
    },
    filterAnswers: {
      type: Boolean,
      default: true,
    },
    markCorrect: {
      type: Boolean,
      default: false,
    },
    answersHaveSwitch: {
      type: Boolean,
      default: false,
    },
    initialAnswers: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      exam,
      calculateQuestionPoints,
      calculateAnswerPoints,
      getAnswerPoints,
      isSimpleQuestion,
      selectedToRemoveAnswers: { ...this.initialAnswers },
    };
  },
  methods: {
    onToggle(key, newValue) {
      this.$emit("dict-updated", { [key]: newValue });

      this.selectedToRemoveAnswers[key] = newValue;
    },
    endWith(string) {
      return string.endsWith(":");
    },
  },
};
</script>
